module.exports = __webpack_public_path__ + "static/media/view-icon.62eb2f4b.svg";